let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aqnFU")).then(() => parcelRequire('jYKHD'));